import React, { useState, useEffect } from "react";
import "./../../../Services/http";
import http from "./../../../Services/http";
import Loader from "react-loader-spinner";
import "./MangeUsers.css";

const MangeUsers = () => {
  const [users, setUsers] = useState([]);
  const [, setLoader] = useState(false);

  useEffect(() => {
    let fetchUsers;
    try {
      setLoader(true);
      fetchUsers = async () => {
        const { data } = await http.get("/users", {
          headers: {
            "x-token": localStorage.getItem("token"),
          },
        });

        setUsers(data.users);
      };
    } catch (error) {
      setLoader(false);
      console.log(error);
    }

    fetchUsers();
  }, []);
  return (
    <div className="users">
      <div className="users__content">
        {!users ? (
          <Loader type="ThreeDots" color="#ef92c8" height={200} width={200} />
        ) : (
          users.map((user) => (
            <div key={user._id} className="user">
              <div className="user__img--container">
                <img
                  className="user__img"
                  src={process.env.REACT_APP_IMAGES_URL + user.userImage}
                  alt="profile"
                />
              </div>

              <div className="user__text">
                <h3 className="user__title">{user.name}</h3>
                <p className="user__email">{user.email}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MangeUsers;
